import angular from 'angular';
import _ from 'underscore';
import $ from 'jquery';

export default class ItemDialog {
  constructor($scope, $rootScope, ItemService, ProductService, UiService) {
    function get_dialog_data() {
      ItemService.get_dialog_data().success(function(data) {
        $scope.product_categories = data.product_categories;
        $scope.product_brands = data.product_brands;
        $scope.product_colors = data.product_colors;
      });
    }

    function set_product_data() {
      if ($scope.products && $scope.item && $scope.item.product_id) {
        var product = _.findWhere($scope.products, {
          id: $scope.item.product_id
        });
        if (product) {
          var product_grade = _.findWhere($scope.product_grades, {
            id: product.product_grade_id
          });
          if (product_grade)
            $scope.item.product_grade = product_grade.title;

          var product_type = _.findWhere($scope.product_types, {
            id: product.product_type_id
          });
          if (product_type)
            $scope.item.product_type = product_type.title;

          var product_finish = _.findWhere($scope.product_finishes, {
            id: product.product_finish_id
          });
          if (product_finish)
            $scope.item.product_finish = product_finish.title;
        }
      }
    }

    $scope.$watch('item.product_category_id', function() {
      if ($scope.item && $scope.item.product_category_id) {
        ProductService.get_groups($scope.item.product_category_id).then(function(data) {
          $scope.product_groups = data.groups;
          if (!_.findWhere(data.groups, {id: $scope.item.product_group_id})) {
            $scope.item.product_group_id = null;
          }
        });
      } else if ($scope.item) {
        $scope.item.product_group_id = null;
        $scope.product_groups = [];
        $scope.products = [];
      }
      ProductService.get_product_properties_by_category($scope.item ? $scope.item.product_category_id : null).then(function(data) {
        $scope.product_grades = data.product_grades;
        $scope.product_types = data.product_types;
        $scope.product_finishes = data.product_finishes;
        $scope.product_printing_methods = data.product_printing_methods;
      });
    });

    $scope.$watch('item.product_group_id', function() {
      if ($scope.item && $scope.item.product_group_id) {
        ProductService.get_products($scope.item.product_group_id).then(function(data) {
          $scope.products = data.products;
          if (!_.findWhere(data.products, {id: $scope.item.product_id}))
            $scope.item.product_id = null;
          set_product_data();
        });
      } else if ($scope.item) {
        $scope.item.product_id = null;
        $scope.products = [];
      }
    });

    $scope.$watch('item.product_id', function() {
      set_product_data();
    });

    $scope.$on('show_item_dialog', function(event, data) {
      $scope.item = angular.copy(data.item);
      $scope.edit_items = data.items || null;
      window.openFancyboxDialog('div#item_dialog');
    });

    $scope.save = function() {
      $scope.saving = true;
      if (!$scope.edit_items) {
        ItemService.save($scope.item).success(function(data) {
          if (data.success) {
            $rootScope.$broadcast('load_items');
            $scope.saving = false;
            $.fancybox.close();
          }
        });
      } else {
        ItemService.mass_save($scope.item, $scope.edit_items).success(function(data) {
          if (data.success) {
            $rootScope.$broadcast('load_items', {
              selected_items: $scope.edit_items,
              item_key: 'item_id'
            });
            $scope.saving = false;
            $.fancybox.close();
          }
        });
      }
    };

    $scope.init = function() {
      $scope.select2_options = UiService.select2_options(100);
      $scope.stock_types = ItemService.get_stock_types();
      get_dialog_data();
    };

    $scope.init();

  }
}

ItemDialog.$inject = ['$scope', '$rootScope', 'ItemService', 'ProductService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/item-dialog.ctrl.js